const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = ["00", "15", "30", "45"];

export default function TimeSelect({ value = "09:00", onChange, className = "" }) {
  const [h, m] = (value || "09:00").split(":");

  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <select
        value={h}
        onChange={(e) => onChange(`${e.target.value}:${m}`)}
        className="h-9 rounded-lg border border-border bg-background px-2 text-xs outline-none appearance-none cursor-pointer"
      >
        {HOURS.map((hour) => (
          <option key={hour} value={hour}>{hour}</option>
        ))}
      </select>
      <span className="text-xs text-muted-foreground font-semibold">:</span>
      <select
        value={m}
        onChange={(e) => onChange(`${h}:${e.target.value}`)}
        className="h-9 rounded-lg border border-border bg-background px-2 text-xs outline-none appearance-none cursor-pointer"
      >
        {MINUTES.map((min) => (
          <option key={min} value={min}>{min}</option>
        ))}
      </select>
    </div>
  );
}
